import ArrowDown from './arrow-down'
import ArrowUp from './arrow-up'
import ArrowLeft from './arrow-left'
import ArrowRight from './arrow-right'
import ChevronLeft from './chevron-left'
import ChevronRight from './chevron-right'
import ChevronUp from './chevron-up'
import ChevronDown from './chevron-down'
import YouTube from './social-youtube'
import LinkedIn from './social-linkedin'
import Facebook from './social-facebook'
import BrandLogo from './brand-logo'
import MagnifyingGlass from './magnifying-glass'
import Bars3 from './bars-3'
import XMark from './x-mark'
import FlagIt from './flags/flag-it'
import FlagEn from './flags/flag-en'
import FlagCs from './flags/flag-cs'
import FlagRo from './flags/flag-ro'
import FlagHu from './flags/flag-hu'
import FlagBg from './flags/flag-bg'
import FlagDe from './flags/flag-de'
import FlagPl from './flags/flag-pl'
import FlagFr from './flags/flag-fr'
import FlagRu from './flags/flag-ru'
import FlagSk from './flags/flag-sk'
import ArrowUpRight from './arrow-up-right'
import Download from './download'
import LeafGreen from './leaf-green'
import QuoteOpen from './quote-open'
import LeafDiagonal from './leaf-diagonal'
import Circle from './circle'
import LeafGreenBig from './leaf-green-big'
import Upload from './upload'
import PinMain from './pin-main'
import PinPartner from './pin-partner'
import Eye from './eye'
import Check from './check'
import FourSquare from './four-square'
import ResourceCategory from './resourceHub/resource-category'
import Industry from './resourceHub/industry'
import Gas from './resourceHub/gas'
import GasType from './resourceHub/gas-type'
import CaseStudy from './resourceHub/case-study'
import Whitepaper from './resourceHub/whitepaper'
import TechnicalSheet from './resourceHub/technical-sheet'
import SafetyDatasheet from './resourceHub/safety-datasheet'
import Certification from './resourceHub/certification'
import Spinner from './resourceHub/spinner'
import Filters from './resourceHub/filters'
import Trash from './trash'

const Glyphs = {
    'arrow-down': ArrowDown, 
    'arrow-left': ArrowLeft,
    'arrow-right': ArrowRight, 
    'arrow-up': ArrowUp, 
    'chevron-left': ChevronLeft, 
    'chevron-right': ChevronRight, 
    'chevron-up': ChevronUp,
    'chevron-down': ChevronDown,
    'youtube': YouTube,
    'linkedin': LinkedIn,
    'facebook': Facebook,
    'brand-logo': BrandLogo,
    'magnifying-glass': MagnifyingGlass,
    'bars-3': Bars3,
    'x-mark': XMark,
    'flag-it': FlagIt,
    'flag-en': FlagEn,
    'flag-cs': FlagCs,
    'flag-ro': FlagRo,
    'flag-hu': FlagHu,
    'flag-bg': FlagBg,
    'flag-de': FlagDe,
    'flag-pl': FlagPl,
    'flag-fr': FlagFr,
    'flag-ru': FlagRu,
    'flag-sk': FlagSk,
    'arrow-up-right': ArrowUpRight,
    'download': Download,
    'leaf-green': LeafGreen,
    'quote-open': QuoteOpen,
    'leaf-diagonal': LeafDiagonal,
    'circle': Circle,
    'leaf-green-big': LeafGreenBig,
    'upload': Upload,
    'pin-main': PinMain,
    'pin-partner': PinPartner,
    'eye': Eye,
    'check': Check,
    'four-square': FourSquare,
    'resourceCategory': ResourceCategory,
    'industry': Industry,
    'gas': Gas,
    'gasType': GasType,
    'caseStudy': CaseStudy,
    'whitepaper': Whitepaper,
    'technicalSheet': TechnicalSheet,
    'safetyDatasheet': SafetyDatasheet,
    'certification': Certification,
    'spinner': Spinner,
    'filters': Filters,
    'trash': Trash,
}

export default Glyphs